import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Button, Dimmer, Dropdown, Loader, Modal} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';
import {mapListToDropdownList} from '../../../../floatingInventory/utils/commonUtils';
const {
  setSelectedVehicleAgency,
  updateVehicleAgency,
  fetchAgenciesByDealer,
} = Actions;
const UpdateAgencyModal = ({openAgencyModals, setOpenAgencyModals}) => {
  const dispatch = useDispatch();
  const [dealerListDropDown, setDealerListDropDownist] = useState([]);
  const [agencyListDropDown, setAgencyListDropDownist] = useState([]);
  const {
    loadingCombos,
    loadingUpdateAgency,
    selectedVehicleAgency,
  } = useSelector((state) => state.priorizationDates);
  const dealersList = useSelector((state) => state.dealer.list);
  const agencyList = useSelector((state) => state.dealer.agenciesList);
  useEffect(() => {
    setDealerListDropDownist(mapListToDropdownList(
    
      dealersList,
      {
        'keys': ['identification'],
        'values': ['identification'],
        'texts': ['name'],
      },
      false, '/'));
  }, [dealersList]);
  const handleAgencys = () => {
    setAgencyListDropDownist(mapListToDropdownList(
      agencyList,
      {
        'keys': ['code'],
        'values': ['code'],
        'texts': ['name'],
      },
      false, '/'));
  };
  useEffect(() => {
    handleAgencys();
  }, [agencyList]);
  const handleChangeDealer = (value) => {
    dispatch(fetchAgenciesByDealer({
      'dealerId': value,
      'priorization': 'S',
    }));
    dispatch(setSelectedVehicleAgency({
      ...selectedVehicleAgency,
      'dealerDestiny': value,
    }));
  };
  
  const handleChangeAgency = (value) => {
    dispatch(setSelectedVehicleAgency({
      ...selectedVehicleAgency,
      'agency': value,
    }));
  };
  const handleUpdateAgencie = () => {
    dispatch(updateVehicleAgency({'data': selectedVehicleAgency}));
    dispatch(setSelectedVehicleAgency(
      {...selectedVehicleAgency,
        'chassis': '',
        'dealerDestiny': '',
        'agency': '',
      }));
    setOpenAgencyModals(false);
  };
  const handleClose = () => {
    setOpenAgencyModals(false);
    dispatch(setSelectedVehicleAgency(
      {...selectedVehicleAgency,
        'chassis': '',
        'dealerDestiny': '',
        'agency': '',
      }));
  };
  return (
    <Modal
      size={'mini'}
      open={openAgencyModals}
    >
      <Dimmer active={loadingUpdateAgency} inverted>
        <Loader />
      </Dimmer>
      <Modal.Header>Modificar Dealer/Agencia</Modal.Header>
      <Modal.Content>
        <label><h4>{selectedVehicleAgency?.chassis}</h4></label>
        <br/>
        <Dropdown
          loading={loadingCombos}
          placeholder='Seleccione el dealer deseado'
          value={selectedVehicleAgency?.dealerDestiny}
          fluid
          selection
          options={dealerListDropDown}
          onChange={(e, {value}) => handleChangeDealer(value)}
        />
        <Dropdown
          loading={loadingCombos}
          placeholder='Seleccione la agencia deseada'
          value={selectedVehicleAgency?.agency}
          fluid
          selection
          options={agencyListDropDown}
          onChange={(e, {value}) => handleChangeAgency(value)}
        />
      </Modal.Content>
      <Modal.Actions>
        <Button
          basic
          onClick={handleClose}
        >
          Cancelar
        </Button>
        <Button
          primary
          onClick={handleUpdateAgencie}
        >
          Actualizar
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
export default UpdateAgencyModal;
